import React from 'react';
import Helmet from 'react-helmet';

import HelpContactUs from '../../../components/HelpContactUs/HelpContactUs';
import SheetTitle from '../../../components/SheetTitle';
import BackButton from '../../../components/BackButton';
import c from '../Help.less';

export default function () {
  return (
    <div className={c.content}>
      <Helmet defer={false}>
        <meta property="mc:dp" content="/shop/help/advertisement" />
      </Helmet>
      <BackButton to="/shop/help" />
      <SheetTitle title="Advertisement" />
      <p>
        Our service is a paid one and we do not do advertisement and never will.
      </p>
      <HelpContactUs subject={2} />
    </div>
  );
}
